export const BASIC_SAVE = 'BASIC_SAVE';
export const RESET_FIELDS = 'RESET_FIELDS';

